<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="390"
    >
        <v-card>
            <v-container class="my-2">
                <v-card-title class="text-md-h6 text-center text-break font-weight-bold">
                    {{ $t('reports.messages.cancel_report_generation') }}
                </v-card-title>
                <v-card-actions class="justify-center">
                    <v-btn
                        class="v-btn--red"
                        text
                        @click="confirmDialog"
                    >
                        {{ $t('app.confirm') }}
                    </v-btn>
                    <v-btn
                        class="v-btn--secondary"
                        text
                        @click="closeDialog"
                    >
                        {{ $t('app.cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "CancelReportGenerationDialog",

    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        reportType: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {

        }
    },

    methods: {

        /**
         * Emits dialog confirmed event
         */
        confirmDialog() {
            this.$emit('ConfirmDialog')
        },

        /**
         * Closes de confirmation dialog
         */
        closeDialog() {
            this.$emit('CancelDialog', this.showDialog)
        }

    }
}
</script>

<style scoped>

</style>
